import { useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Collapse,
  IconButton,
  Drawer,
  List,
  ListItemText,
  Box,
  Divider,
  Menu,
  MenuItem,
  Button,
  ListItemButton
} from "@mui/material";
import { AccountCircle, Logout } from "@mui/icons-material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

const drawerWidth = 240;

const DashboardLayout = ({ children, title }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [openPaymentsMenu, setOpenPaymentsMenu] = useState(false);
  const navigate = useNavigate();

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const clearAuthStorage = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("role");
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("role");
  };

  const handleLogout = () => {
    const savedRememberMe = localStorage.getItem("savedRememberMe");

    clearAuthStorage();

    if (savedRememberMe !== "true") {
      localStorage.removeItem("savedEmail");
      localStorage.removeItem("savedRememberMe");
    }

    handleMenuClose();
    navigate("/login");
  };

  return (
    <Box sx={{ display: "flex" }}>
      {/* Üst Navigasyon */}
      <AppBar position="fixed" sx={{ zIndex: 1300 }}>
        <Toolbar>
          <Typography variant="h6" sx={{ flexGrow: 1, display: "flex", alignItems: "center" }}>
            <img
              src="/bilogo.png"
              alt="Admin Logo"
              width={50}
              height={50}
              style={{ marginRight: 8 }}
            />
            BI Admin Panel
          </Typography>

          <IconButton color="inherit" onClick={handleMenuOpen}>
            <AccountCircle />
          </IconButton>

          <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
            <MenuItem
              onClick={() => {
                handleMenuClose();
                navigate("/profile");
              }}
            >
              Profil
            </MenuItem>
            <MenuItem
              onClick={() => {
                handleMenuClose();
                navigate("/settings");
              }}
            >
              Ayarlar
            </MenuItem>
          </Menu>

          <Button
            variant="contained"
            color="error"
            startIcon={<Logout />}
            onClick={handleLogout}
            sx={{ ml: 2, textTransform: "none" }}
          >
            Çıkış
          </Button>
        </Toolbar>
      </AppBar>

      {/* Sidebar */}
      <Drawer
        variant="permanent"
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: drawerWidth,
            boxSizing: "border-box",
            backgroundColor: "#1565C0",
            color: "white",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            height: "100vh"
          },
        }}
      >
        <Box>
          <Typography variant="h6" align="center" sx={{ p: 2 }}>
            Admin Menü
          </Typography>
          <Divider sx={{ backgroundColor: "#0D47A1" }} />

          <List>
            <ListItemButton onClick={() => navigate("/dashboard")}>
              <ListItemText
                disableTypography
                primary={<Typography sx={{ fontSize: "1.2rem", fontWeight: "bold", color: "white" }}>Ana Sayfa</Typography>}
              />
            </ListItemButton>
            <Divider sx={{ backgroundColor: "#0D47A1" }} />

            <ListItemButton onClick={() => navigate("/users")}>
              <ListItemText
                disableTypography
                primary={<Typography sx={{ fontSize: "1.2rem", fontWeight: "bold", color: "white" }}>Kullanıcılar</Typography>}
              />
            </ListItemButton>
            <Divider sx={{ backgroundColor: "#0D47A1" }} />

            <ListItemButton onClick={() => navigate("/subscriptions")}>
              <ListItemText
                disableTypography
                primary={<Typography sx={{ fontSize: "1.2rem", fontWeight: "bold", color: "white" }}>Abonelikler</Typography>}
              />
            </ListItemButton>
            <Divider sx={{ backgroundColor: "#0D47A1" }} />

            <ListItemButton onClick={() => navigate("/packages")}>
              <ListItemText
                disableTypography
                primary={<Typography sx={{ fontSize: "1.2rem", fontWeight: "bold", color: "white" }}>Paketler</Typography>}
              />
            </ListItemButton>
            <Divider sx={{ backgroundColor: "#0D47A1" }} />

            <ListItemButton onClick={() => navigate("/campaign")}>
              <ListItemText
                disableTypography
                primary={<Typography sx={{ fontSize: "1.2rem", fontWeight: "bold", color: "white" }}>Kampanyalar</Typography>}
              />
            </ListItemButton>
            <Divider sx={{ backgroundColor: "#0D47A1" }} />

            <ListItemButton onClick={() => navigate("/bots")}>
              <ListItemText
                disableTypography
                primary={<Typography sx={{ fontSize: "1.2rem", fontWeight: "bold", color: "white" }}>Botlar</Typography>}
              />
            </ListItemButton>
            <Divider sx={{ backgroundColor: "#0D47A1" }} />

            <ListItemButton onClick={() => navigate("/educationmat")}>
              <ListItemText
                disableTypography
                primary={<Typography sx={{ fontSize: "1.2rem", fontWeight: "bold", color: "white" }}>Eğitim İçerikleri</Typography>}
              />
            </ListItemButton>
            <Divider sx={{ backgroundColor: "#0D47A1" }} />

            <ListItemButton onClick={() => setOpenPaymentsMenu(!openPaymentsMenu)}>
              <ListItemText
                disableTypography
                primary={
                  <Typography
                    sx={{
                      fontSize: "1.2rem",
                      fontWeight: "bold",
                      color: "white",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center"
                    }}
                  >
                    Ödemeler
                    {openPaymentsMenu ? <ExpandLess sx={{ fontSize: 20 }} /> : <ExpandMore sx={{ fontSize: 20 }} />}
                  </Typography>
                }
              />
            </ListItemButton>

            <Collapse in={openPaymentsMenu} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItemButton sx={{ pl: 4 }} onClick={() => navigate("/payments/overview")}>
                  <ListItemText
                    primary={<Typography sx={{ fontSize: "1rem", fontWeight: "bold", color: "white" }}>Genel Bakış</Typography>}
                  />
                </ListItemButton>
                <ListItemButton sx={{ pl: 4 }} onClick={() => navigate("/payments/users")}>
                  <ListItemText
                    primary={<Typography sx={{ fontSize: "1rem", fontWeight: "bold", color: "white" }}>Kullanıcı Ödemeleri</Typography>}
                  />
                </ListItemButton>
                <ListItemButton sx={{ pl: 4 }} onClick={() => navigate("/payments/errors")}>
                  <ListItemText
                    primary={<Typography sx={{ fontSize: "1rem", fontWeight: "bold", color: "white" }}>Ödeme Hataları</Typography>}
                  />
                </ListItemButton>
              </List>
            </Collapse>
            <Divider sx={{ backgroundColor: "#0D47A1" }} />

            <ListItemButton onClick={() => navigate("/support")}>
              <ListItemText
                disableTypography
                primary={<Typography sx={{ fontSize: "1.2rem", fontWeight: "bold", color: "white" }}>Destek Talepleri</Typography>}
              />
            </ListItemButton>
            <Divider sx={{ backgroundColor: "#0D47A1" }} />

            <ListItemButton onClick={() => navigate("/feedback")}>
              <ListItemText
                disableTypography
                primary={<Typography sx={{ fontSize: "1.2rem", fontWeight: "bold", color: "white" }}>Geri Bildirimler</Typography>}
              />
            </ListItemButton>
            <Divider sx={{ backgroundColor: "#0D47A1" }} />
          </List>
        </Box>

        {/* En alttaki çıkış */}
        <Box>
          <Button
            variant="contained"
            color="error"
            fullWidth
            onClick={handleLogout}
            sx={{ borderRadius: 0, padding: "12px", fontSize: "1rem" }}
          >
            Çıkış
          </Button>
        </Box>
      </Drawer>

      <Box component="main" sx={{ flexGrow: 1, mt: 8, ml: `${drawerWidth}px` }}>
        <Box
          sx={{
            backgroundColor: "#f5f5f5",
            padding: "16px",
            borderRadius: "0px",
            mb: 3,
            zIndex: 99,
            position: "sticky",
            top: "64px",
            width: `calc(100% + ${drawerWidth}px)`,
            ml: `-${drawerWidth}px`
          }}
        >
          <Typography variant="h5" sx={{ fontWeight: "bold" }}>
            {title}
          </Typography>
        </Box>

        <Box
          sx={{
            padding: "16px",
            borderRadius: "0px",
            mb: 3,
            width: `calc(100% + ${drawerWidth}px)`,
            ml: `calc(-${drawerWidth}px)`
          }}
        >
          {children}
        </Box>
      </Box>
    </Box>
  );
};

export default DashboardLayout;